/* eslint-disable */
let filters = [{
  title: 'Grades',
  items: [{
    id: 'all',
    title: 'All Grades',
    altTitle : 'All Ages',
    selected: true
  }, {
    id: -1,
    title: 'Pre-Kindergarten',
    altTitle: '4 - 5',
    selected: false
  },
    {
      id: 0,
      title: 'Kindergarten',
      altTitle: '5 - 6',
      selected: false
    }, {
      id: 1,
      title: 'Grade 1',
      altTitle: '6 - 7',
      selected: false
    }, {
      id: 2,
      title: 'Grade 2',
      altTitle: '7 - 8',
      selected: false
    }, {
      id: 3,
      title: 'Grade 3',
      altTitle: '8 - 9',
      selected: false
    }, {
      id: 4,
      title: 'Grade 4',
      altTitle: '9 - 10',
      selected: false
    }, {
      id: 5,
      title: 'Grade 5',
      altTitle: '10 - 11',
      selected: false
    }, {
      id: 6,
      title: 'Grade 6',
      altTitle: '11 - 12',
      selected: false
    }, {
      id: 7,
      title: 'Grade 7',
      altTitle: '12 - 13',
      selected: false
    }, {
      id: 8,
      title: 'Grade 8',
      altTitle: '13 - 14',
      selected: false
    }, {
      id: 9,
      title: 'Grade 9',
      altTitle: '14 - 15',
      selected: false
    }, {
      id: 10,
      title: 'Grade 10',
      altTitle: '15 - 16',
      selected: false
    }, {
      id: 11,
      title: 'Grade 11',
      altTitle: '16 - 17',
      selected: false
    }, {
      id: 12,
      title: 'Grade 12',
      altTitle: '17 - 18',
      selected: false
    }, {
      id: 13,
      title: 'Post-Secondary',
      altTitle: '18+',
      selected: false
    }]
},
  {
    title: 'Subjects',
    items: [{
      id:'all',
      title: 'All Subjects',
      selected: true
    },
      {id:'Arts Education',
      title: 'Arts Education',
      selected: false
      },
      {id: 'Career Technical Education',
       title: 'Career Technical Education',
       selected: false
      },
      {id: 'Health and PE',
       title: 'Health and PE',
       selected: false
      },
      {id: 'Language Arts',
       title: 'Language Arts',
       selected: false
      },
      {id: 'Library Media',
       title: 'Library & Media',
       selected: false
      },
      {id: 'Mathematics',
       title: 'Mathematics',
       selected: false
      },
      {id: 'Science',
       title: 'Science',
       selected: false
      },
      {id: 'Social Studies',
       title: 'Social Studies',
       selected: false
      },
      {id: 'Technology Education',
       title: 'Technology Education',
       selected: false
      },
      {id: 'World Languages',
       title: 'World Languages',
       selected: false
      }]
  },
  {
    title: 'Standards',
    items: [
      {
        id: "none",
        title: 'None',
        selected: true
      },
      {
        id: "CCSI",
        title: "Common Core College and Career Readiness Anchor Standards",
        selected: false
      },
      {
        id: "CCK12",
        title: "Common Core State Standards",
        selected: false
      },
      {
        id: "ACTFL",
        title: "ACTFL Standards",
        selected: false
      },
      {
        id: "NETSS",
        title: "ISTE for Students (ISTE-S)",
        selected: false
      },
      {
        id: "NHES",
        title: "National Health Education Standards (NHES)",
        selected: false
      },
      {
        id: "SHAPE",
        title: "SHAPE America National Standards for K-12 Physical Education (SHAPE)",
        selected: false
      },
      {
        id: "NCHS",
        title: "NCHS Standards",
        selected: false
      },
      {
        id: "NCSE",
        title: "NCSE Standards",
        selected: false
      },
      {
        id: "NCSS",
        title: "NCSS Standards",
        selected: false
      },
      {
        id: "NCTE",
        title: "NCTE Standards",
        selected: false
      },
      {
        id: "NCTMS",
        title: "NCTM Standards",
        selected: false
      },
      {
        id: "NRCDSC",
        title: "Next Generation Science Standards",
        selected: false
      },
      {
        id: "AL",
        title: "Alabama",
        selected: false
      },
      {
        id: "AK",
        title: "Alaska",
        selected: false
      },
      {
        id: "AZ",
        title: "Arizona",
        selected: false
      },
      {
        id: "AR",
        title: "Arkansas",
        selected: false
      },
      {
        id: "CA",
        title: "California",
        selected: false
      },
      {
        id: "CO",
        title: "Colorado",
        selected: false
      },
      {
        id: "CT",
        title: "Connecticut",
        selected: false
      },
      {
        id: "DE",
        title: "Delaware",
        selected: false
      },
      {
        id: "FL",
        title: "Florida",
        selected: false
      },
      {
        id: "GA",
        title: "Georgia",
        selected: false
      },
      {
        id: "HI",
        title: "Hawaii",
        selected: false
      },
      {
        id: "ID",
        title: "Idaho",
        selected: false
      },
      {
        id: "IL",
        title: "Illinois",
        selected: false
      },
      {
        id: "IN",
        title: "Indiana",
        selected: false
      },
      {
        id: "IA",
        title: "Iowa",
        selected: false
      },
      {
        id: "KS",
        title: "Kansas",
        selected: false
      },
      {
        id: "KY",
        title: "Kentucky",
        selected: false
      },
      {
        id: "LA",
        title: "Louisiana",
        selected: false
      },
      {
        id: "ME",
        title: "Maine",
        selected: false
      },
      {
        id: "MD",
        title: "Maryland",
        selected: false
      },
      {
        id: "MA",
        title: "Massachusetts",
        selected: false
      },
      {
        id: "MI",
        title: "Michigan",
        selected: false
      },
      {
        id: "MN",
        title: "Minnesota",
        selected: false
      },
      {
        id: "MS",
        title: "Mississippi",
        selected: false
      },
      {
        id: "MO",
        title: "Missouri",
        selected: false
      },
      {
        id: "MT",
        title: "Montana",
        selected: false
      },
      {
        id: "NE",
        title: "Nebraska",
        selected: false
      },
      {
        id: "NV",
        title: "Nevada",
        selected: false
      },
      {
        id: "NH",
        title: "New Hampshire",
        selected: false
      },
      {
        id: "NJ",
        title: "New Jersey",
        selected: false
      },
      {
        id: "NM",
        title: "New Mexico",
        selected: false
      },
      {
        id: "NY",
        title: "New York",
        selected: false
      },
      {
        id: "NC",
        title: "North Carolina",
        selected: false
      },
      {
        id: "ND",
        title: "North Dakota",
        selected: false
      },
      {
        id: "OH",
        title: "Ohio",
        selected: false
      },
      {
        id: "OK",
        title: "Oklahoma",
        selected: false
      },
      {
        id: "OR",
        title: "Oregon",
        selected: false
      },
      {
        id: "PA",
        title: "Pennsylvania",
        selected: false
      },
      {
        id: "RI",
        title: "Rhode Island",
        selected: false
      },
      {
        id: "SC",
        title: "South Carolina",
        selected: false
      },
      {
        id: "SD",
        title: "South Dakota",
        selected: false
      },
      {
        id: "TN",
        title: "Tennessee",
        selected: false
      },
      {
        id: "TX",
        title: "Texas",
        selected: false
      },
      {
        id: "UT",
        title: "Utah",
        selected: false
      },
      {
        id: "VT",
        title: "Vermont",
        selected: false
      },
      {
        id: "VA",
        title: "Virginia",
        selected: false
      },
      {
        id: "DC",
        title: "Washington DC",
        selected: false
      },
      {
        id: "WA",
        title: "Washington",
        selected: false
      },
      {
        id: "WV",
        title: "West Virginia",
        selected: false
      },
      {
        id: "WI",
        title: "Wisconsin",
        selected: false
      },
      {
        id: "WY",
        title: "Wyoming",
        selected: false
      },
      {
        id: "AB",
        title: "Alberta Standards",
        selected: false
      },
      {
        id: "ACCS",
        title: "Atlantic Canada Curriculum Standards",
        selected: false
      },
      {
        id: "BC",
        title: "British Columbia Standards",
        selected: false
      },
      {
        id: "MB",
        title: "Manitoba Standards",
        selected: false
      },
      {
        id: "NB",
        title: "New Brunswick Standards",
        selected: false
      },
      {
        id: "NF",
        title: "Newfoundland and Labrador Standards",
        selected: false
      },
      {
        id: "NS",
        title: "Nova Scotia Standards",
        selected: false
      },
      {
        id: "ON",
        title: "Ontario Standards",
        selected: false
      },
      {
        id: "PE",
        title: "Prince Edward Island Standards",
        selected: false
      },
      {
        id: "QC",
        title: "Quebec Standards",
        selected: false
      },
      {
        id: "SK",
        title: "Saskatchewan Standards",
        selected: false
      },
      {
        id: "ENG",
        title: "National Curriculum for England",
        selected: false
      },
      {
        id: "CCTCAG",
        title: "Agriculture, Food & Natural Resources (CCTC)",
        selected: false
      },
      {
        id: "CCTCAC",
        title: "Architecture & Construction (CCTC)",
        selected: false
      },
      {
        id: "CCTCAR",
        title: "Arts, A/V Technology & Communications (CCTC)",
        selected: false
      },
      {
        id: "CCTCBM",
        title: "Business Management & Administration (CCTC)",
        selected: false
      },
      {
        id: "CCTCED",
        title: "Education & Training (CCTC)",
        selected: false
      },
      {
        id: "CCTCFN",
        title: "Finance (CCTC)",
        selected: false
      },
      {
        id: "CCTCGV",
        title: "Government & Public Administration (CCTC)",
        selected: false
      },
      {
        id: "CCTCHL",
        title: "Health Science (CCTC)",
        selected: false
      },
      {
        id: "CCTCHT",
        title: "Hospitality & Tourism (CCTC)",
        selected: false
      },
      {
        id: "CCTCHU",
        title: "Human Services (CCTC)",
        selected: false
      },
      {
        id: "CCTCIT",
        title: "Information Technology (CCTC)",
        selected: false
      },
      {
        id: "CCTCLW",
        title: "Law, Public Safety, Corrections & Security (CCTC)",
        selected: false
      },
      {
        id: "CCTCMN",
        title: "Manufacturing (CCTC)",
        selected: false
      },
      {
        id: "CCTCMK",
        title: "Marketing (CCTC)",
        selected: false
      },
      {
        id: "CCTCST",
        title: "Science, Technology, Engineering & Mathematics (CCTC)",
        selected: false
      },
      {
        id: "CCTCTD",
        title: "Transportation, Distribution & Logistics (CCTC)",
        selected: false
      },
      {
        id: "NCSC",
        title: "NCSC Core Content Connectors",
        selected: false
      },
      {
        id: "NCCAS",
        title: "National Coalition for Core Arts Standards (NCCAS)",
        selected: false
      },
      {
        id: "ACT",
        title: "Australian Capital Curriculum",
        selected: false
      },
      {
        id: "ACARAS",
        title: "Australian Curriculum (ACARA)",
        selected: false
      },
      {
        id: "NSW",
        title: "New South Wales Standards",
        selected: false
      },
      {
        id: "NTA",
        title: "Northern Territory Curriculum",
        selected: false
      },
      {
        id: "QLD",
        title: "Queensland Curriculum",
        selected: false
      },
      {
        id: "SAU",
        title: "South Australia Curriculum",
        selected: false
      },
      {
        id: "TAS",
        title: "Tasmanian Curriculum",
        selected: false
      },
      {
        id: "VIC",
        title: "Victorian Curriculum",
        selected: false
      },
      {
        id: "WAU",
        title: "Western Australia Curriculum",
        selected: false
      },
      {
        id: "NZ",
        title: "New Zealand Curriculum Standards",
        selected: false
      },
      {
        id: "NCERTLA",
        title: "India English Classes I-XII (NCERT)",
        selected: false
      },
      {
        id: "NCERTMA",
        title: "India Mathematics Classes I-XII (NCERT)",
        selected: false
      },
      {
        id: "NCERTSC",
        title: "India Science Classes VI-XII (NCERT)",
        selected: false
      },
      {
        id: "NCERTSS",
        title: "India Social Science Classes VI-XII (NCERT)",
        selected: false
      }
    ]
  },
  {
    title: 'Strands',
    items: []
  },
  {
    title: 'Location',
    items: []
  },
  {
    title: 'Resource Type',
    items: [{
      id: 'all',
      title: 'All Types',
      selected: true
    }, {
      id: 'LESSON',
      title: "Lessons",
      selected: false
    }, {
      id: 'ACTIVITY',
      title: 'Activities',
      selected: false
    }, {
      id: 'ASSESSMENT',
      title: 'Assessments',
      selected: false
    }, {
      id: 'TEMPLATE',
      title: 'Templates',
      selected: false
    }, {
      id: 'CLASSROOM_TOOLS',
      title: 'Teacher Tools',
      selected: false
    }]
  }
  ]


let authorFilter = {
  author: null
}

let keywordFilter = {
  keyword: null
}

let sorting = {
  title: 'Sorting',
  items: [{
    id: 'bestmatch',
    title: 'Best match',
    selected: true
  }, {
    id: 'mostpopular',
    title: 'Most popular',
    selected: false
  }]
}

let pagination = {
  pageSize: 9,
  pageNumber: 1
}

export default {
  homeContent: [],
  content: {},
  supportedCountries: [],
  supportedLanguages: [],
  mobileFiltersVisible: false,
  callout: true,
  locale:{
    fallbackLocale: false
  },
  categories: {
    mostPopular: [],
    studentActivities: [],
    manageYourClassRoom: [],
    trySomethingNew: [],
    featuredContent: [],
    standardsContent: [],
    topPrimary: [],
    topSecondary: [],
    featuredPublisherContent: [],
    selectedCategory: null
  },
  search: {
    userLocation: null,
    searchResults: {
      totalResults: 0,
      items: [],
      strands: [],
      loading: false,
      error: {
        status: ''
      },
      nextPageToken: ''
    },
    textInput: null,
    sorting,
    filters,
    pagination,
    authorFilter,
    keywordFilter
  },
  moderation: {
    resources: {
      pending: {
        items: [],
        loading: false,
        selected: false,
        currentPage: 1
      },
      approved: {
        items: [],
        loading: false,
        selected: true,
        currentPage: 1
      },
      declined: {
        items: [],
        loading: false,
        selected: false,
        currentPage: 1
      },
      queues: {
        items: [],
        loading: false
      },
      resourceDataAdded: false
    }
  },
  moderationQueue: {
    pending: {
      items: [],
      loading: false,
      selected: true,
      currentPage: 1
    },
    declined: {
      items: [],
      loading: false,
      selected: false,
      currentPage: 1
    },
    queues: {
      items: [],
      loading: false
    },
    filters: [{
      title: 'pending locations',
      items: []
    },
      {
        title: 'declined locations',
        items: []
      }]
  },
  langLoadStatus: false
}
